<template>
<div class="app-container">
    <div class="img">
        <img src="../../assets/img/pre_active.jpg" alt="" srcset="">
        <div class="btn">
            <img @click="toPre" src="../../assets/img/pre_btn.png" alt="">
        </div>
    </div>
    <div class="content"></div>
</div>
</template>

<script>
export default {
name: "",
components:{},
data() {
return {};
},
beforeCreate() {},
created() {},
methods: {
    toPre(){
        let obj = this.$store.getters;
        if(obj.token){
            this.$router.push({
                path: "/aboutUsIndex",
                query: { type: 13, tabIndex: '1-1', tabName: '我的资产' },
            });
        }else{
            this.$message.warning("请先登录")
        }
       
    }
},
};
</script>

<style lang='scss' scoped>
.app-container{
    // min-width: 1280px;
    max-width: 1920px;
    margin: 0 auto;
}
.img{
    position: relative;
    max-width: 1700px;
    margin: 20px auto;
    background: #FFFFFF;
    border-radius: 5px;
    text-align: center;
    img{
        width: 65%;
        padding-top: 40px;
    }
    .btn{
        width: 100%;
        position: absolute;
        left: 0%;
        bottom: 9.5%;
        cursor: pointer;
        display: flex;
        z-index: 99;
        justify-content: center;
        img{
            width: 150px;
            height: auto;
            cursor: pointer;
            z-index: 99;
        }
    }
}
</style>